require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/product-list/product-list-v2.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/product-list/product-list-v2.legacy.js
// module id = 698
// module chunks = 31